<template>
  <div class="stores-map">
    <div class="wrapp-map">
      <no-ssr>
        <GmapMap
          class="full-map"
          ref="gMap"
          :center="center"
          :zoom="mapZoom"
          :options="{
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            disableDoubleClickZoom: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false,
            styles: mapStyle
          }"
        >
          <GmapInfoWindow
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false">
            <div v-html="infoContent"></div>
          </GmapInfoWindow>
          <GmapCluster :zoomOnClick="true">
            <GmapMarker
            ref="markers"
            v-for="(store, index) in stores"
            :key="store.code"
            :icon="markerIcon"
            :position="{lat: parseFloat(store.latitude), lng: parseFloat(store.longitude)}"
            :clickable="true"
            :draggable="false"
            @click="toggleInfoWindow(store, index)"
            />
          </GmapCluster>
        </GmapMap>
      </no-ssr>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import { mapStyle } from 'theme/assets/resourcesConfig'
// import StoreLocator from 'theme/pages/StoreLocator'

export default {
  name: 'StoresMap',
  // mixins: [StoreLocator],
  props: {
    stores: {
      type: Array,
      required: true
    },
    isCheckoutMode: {
      type: Boolean,
      default: false
    }
  },
  asyncData ({ store }) {
    return store.dispatch('storeLocator/getAllBoutique')
  },
  data () {
    return {
      mapZoom: 4,
      mapStyle: mapStyle,
      center: {
        lat: parseFloat(this.$store.state.userAdmin.current.latitude) || 30.920677,
        lng: parseFloat(this.$store.state.userAdmin.current.longitude) || -11.5393214
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -30
        }
      },
      markerIcon: require('theme/assets/image/maps/pin/icons-pin.png')
    }
  },
  methods: {
    fitMap () {
      if (this.$refs && this.$refs.gMap && this.$refs.gMap.$mapObject) {
        const mapObject = this.$refs.gMap.$mapObject
        const maps = window.google.maps
        let bounds = new maps.LatLngBounds()
        let markers = this.stores
        for (let i = 0; i < markers.length; i++) {
          if (markers[i].latitude && markers[i].longitude) bounds.extend({ lat: parseFloat(markers[i].latitude), lng: parseFloat(markers[i].longitude) })
        }
        mapObject.fitBounds(bounds)
        mapObject.setZoom(10)
      }
    },
    getMarkerTemplate (location) {
      return `
        <div class="bcm-info-window">
          <div class="wrapp-info">
            <div class="store_info">
              <p class="store-pickup-item-name">${location.name}</p>
              <address class="address">
                <p>${location.address}, ${location.city}</p>
                <p class="phone ${location.phone ? '' : 'd-none'}"><label>Phone</label>:${location.phone}</p>
                <p class="email ${location.email ? '' : 'd-none'}"><a class="bcm-link" href="mailto:${location.email}">${location.email}</a></p>
              </address>
              ${this.renderCheckoutButton(location)}
            </div>
          </div>
        </div>
      `
    },
    renderCheckoutButton (location) {
      // if is checkout mode add select store on marker infowindow
      // else add go to store link
      if (this.isCheckoutMode && location) {
        return `<button class="store-action select-store btn btn-primary btn-primary-black btn-primary-small btn-rounded mt-2" data-store-code="${location.code}">${this.$t('pickup.select-this-store')}</button>`
      } else {
        return `<button class="store-action go-to-store bcm-link t-small" data-store-code="${location.code}">${this.$t('view-detail')}</button>`
      }
    },
    onSelectStore () {
      const _this = this
      // emit event to store this store for checkout shipping method
      $(document).on('click', '.store-action', function () {
        let storeCode = $(this).data('store-code')
        if ($(this).hasClass('select-store')) {
          // select store for pickup
          let currentStore = _this.stores.find((s) => s.code === storeCode)
          return EventBus.$emit('storePickup:selectStore', currentStore)
        } else if ($(this).hasClass('go-to-store')) {
          return _this.$router.push({ name: 'Boutique', params: { store_code: storeCode } })
        } else {
          return null
        }
      })
    },
    toggleInfoWindow (marker, idx) {
      const map = this.$refs.gMap
      const mapObject = map.$mapObject // use this const to access map methods
      this.infoWindowPos = {
        lat: parseFloat(marker.latitude),
        lng: parseFloat(marker.longitude)
      }

      this.infoContent = this.getMarkerTemplate(marker)
      // check if its the same marker that was selected if yes toggle
      if (this.currentMarker === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.infoWinOpen = true
        this.currentMarker = idx
      }
      mapObject.setZoom(16)
      mapObject.setCenter(this.infoWindowPos)
    }
  },
  watch: {
    stores () {
      this.fitMap()
    }
  },
  mounted () {
    if (process.client) {
      this.onSelectStore()
      if (!window.google) {
        this.$gmapApiPromiseLazy().then(() => {
          this.fitMap()
        })
      } else {
        this.fitMap()
      }
    }
  }
}
</script>
